(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cord-length-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function activateTab(tab) {
      var root = tab.closest('.cord-tabs');
      if (!root) return;

      root.querySelectorAll('.cord-tabs__tab').forEach(function (item) {
        var isActive = item === tab;
        var panel = document.getElementById(item.getAttribute('aria-controls'));
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.setAttribute('tabindex', isActive ? '0' : '-1');
        if (panel) panel.hidden = !isActive;
      });
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('.cord-tabs__tab');
      if (tab) activateTab(tab);
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('.cord-tabs__tab');
      if (!tab) return;

      var tabs = Array.prototype.slice.call(tab.closest('.cord-tabs').querySelectorAll('.cord-tabs__tab'));
      var index = tabs.indexOf(tab);
      var next = null;

      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (event.key === 'Home') next = tabs[0];
      if (event.key === 'End') next = tabs[tabs.length - 1];

      if (next) {
        event.preventDefault();
        activateTab(next);
        next.focus();
      }
    });

    // Theme editor: show the tab whose block is selected
    document.addEventListener('shopify:block:select', function (event) {
      if (event.target.classList && event.target.classList.contains('cord-tabs__tab')) {
        activateTab(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.remove('header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-links"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const activeLink = document.querySelector('.page-link-item--active');
        const linksInner = document.querySelector('.links-inner');
        
        if (activeLink && linksInner) {
            activeLink.addEventListener('click', function(e) {
                e.preventDefault();
                linksInner.classList.toggle('visible');
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-extension-cords"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateArrows(root) {
      var track = root.querySelector('.shop-cords__track');
      if (!track) return;
      var prev = root.querySelector('.shop-cords__arrow--prev');
      var next = root.querySelector('.shop-cords__arrow--next');
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function updateAll() {
      document.querySelectorAll('.shop-cords').forEach(updateArrows);
    }

    document.addEventListener('click', function (event) {
      var arrow = event.target.closest('.shop-cords__arrow');
      if (!arrow) return;
      var root = arrow.closest('.shop-cords');
      var track = root.querySelector('.shop-cords__track');
      var direction = Number(arrow.getAttribute('data-direction'));
      track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: 'smooth' });
    });

    // scroll does not bubble, so listen in the capture phase
    document.addEventListener('scroll', function (event) {
      if (event.target.classList && event.target.classList.contains('shop-cords__track')) {
        updateArrows(event.target.closest('.shop-cords'));
      }
    }, true);

    window.addEventListener('resize', updateAll);
    window.addEventListener('load', updateAll);
    document.addEventListener('DOMContentLoaded', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    updateAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
